import './App.css';
import Map from './components/Map';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h2 style={{color:"ghostwhite"}}><b style={{color:"skyblue"}}>G</b>eofusion Demo</h2>
        <p style={{fontSize: 23}}>visualize <b style={{color:"skyblue"}}>| </b> geocode <b style={{color:"skyblue"}}> | </b>route</p>
      </header>
      <Map />
    </div>
  );
}

export default App;
